/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import classnames from 'classnames';
import { useDispatch } from 'react-redux';
import useStyles from './styles';
import Header from '../Header';
import Footer from '../Footer';
import Sidebar from '../Sidebar';
import Dashboard from '../../pages/dashboard';
import List from '../../pages/incidents/List';
import Create from '../../pages/incidents/Create';
import App from '../../pages/apps/App';
import Usages from '../../pages/api-usages';
import ScreensList from '../../pages/custom-login/ScreensList';
import CreateScreen from '../../pages/custom-login/CreateScreen';
import CreateNotification from '../../pages/release-notifications/Create';
import ReleaseNotificationList from '../../pages/release-notifications/List';
import CustomerAccessList from '../../pages/customer-access/List';
import TechStack from '../../pages/tech-stack/techStack'
import AdminPanelAdoption from '../../pages/admin-panel-adoption/list';
import { getConstantsData } from '../../redux/Actions/constants.action';

function Layout(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(getConstantsData()); 
    }, []);

    return (
        <div className={classes.root}>
            <Header history={props.history} sidebar />
            <Sidebar />
            <div className={classes.container}>
                <div
                    className={classnames(classes.content, {
                        [classes.contentShift]: true
                    })}
                >
                    <div className={classes.fakeToolbar} />
                    <Switch>
                        <Route exact path="/app/dashboard" component={Dashboard} />
                        <Route exact path="/app/incidents/list" component={List} />
                        <Route exact path="/app/incidents/create" component={Create} />
                        <Route exact path="/app/application" component={App} />
                        <Route exact path="/app/apiUsage" component={Usages} />
                        <Route exact path="/app/custom-screens" component={ScreensList} />
                        <Route exact path="/app/custom-screens/create" component={CreateScreen} />
                        <Route exact path="/app/notification" component={ReleaseNotificationList} />
                        <Route exact path="/app/customerAccess" component={CustomerAccessList} />
                        <Route exact path="/app/adminPanelAdoption" component={AdminPanelAdoption} />
                        <Route exact path="/app/techStack" component={TechStack} />
                        <Route
                            exact
                            path="/app/custom-screens/create/:id"
                            component={CreateScreen}
                        />
                        <Route exact path="/app/notifications" component={ReleaseNotificationList} />
                        <ConditionalRoute exact path="/app/incidents/edit" component={Create} />
                        <Route exact path="/app/notifications/create" component={CreateNotification} />
                        <Route exact path="/app/notifications/:id" component={CreateNotification} />
                    </Switch>
                </div>
            </div>
            <Footer history={props.history} />
        </div>
    );
}

function ConditionalRoute({ component, ...rest }) {
    return (
        <Route
            {...rest}
            render={(props) =>
                !props.location.state ? (
                    <Redirect to="/app/incidents/list" />
                ) : (
                    React.createElement(component, props)
                )
            }
        />
    );
}

export default withRouter(Layout);
